import PopUp from './PopUP'
export default PopUp